import React, {Component, Fragment} from 'react'
import PropTypes from 'prop-types'
import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {InvestorInfo, Teams, ProblemsSolved, UseOfFunds} from './'
import StyleSheet from 'styles'
import LockIcon from '@material-ui/icons/Lock'
import {FormattedMessage} from 'react-intl'

export class Details extends Component {

  constructor(props) {
    super(props)
    this.state = {
      ...this.state,
      selectedTab: 0
    }
  }

  static propTypes = {
    dealSheet: PropTypes.object,
    className: PropTypes.string,
  }

  handleChange = (event, selectedTab) => {
    this.setState({selectedTab})
  }

  renderPrivateTabLabel = label =>
    <Fragment>{this.props.dealSheet.locked && <LockIcon className={styles.lockIcon}/>}
      <FormattedMessage id={label} />
    </Fragment>

  render = () =>
    <div className={this.props.className}>
      <AppBar position="static" color="inherit">
        <Tabs value={this.state.selectedTab} onChange={this.handleChange} variant='scrollable' scrollButtons="off">
          <Tab label={this.renderPrivateTabLabel('deal.investor_info.title')} value={0} />
          {this.props.dealSheet.typeOfIssuance !== 'product' && <Fragment>
            <Tab label="Problems Solved" value={1} />
            <Tab label="Use of Funds" value={2} />
            <Tab label="Team" value={3} />
          </Fragment>}
        </Tabs>
      </AppBar>
      <div className={styles.content}>
        {this.state.selectedTab === 0 && <InvestorInfo dealSheet={this.props.dealSheet}/>}
        {this.state.selectedTab === 1 && <ProblemsSolved dealSheet={this.props.dealSheet}/>}
        {this.state.selectedTab === 2 && <UseOfFunds dealSheet={this.props.dealSheet}/>}
        {this.state.selectedTab === 3 && <Teams dealSheet={this.props.dealSheet}/>}
      </div>
    </div>
}

const styles = StyleSheet({
  content: {
    marginTop: 50
  },
  lockIcon: {
    margin: '-5px 6px -5px 0',
  }
})

export default Details